export const playersConfig = { min: "1", max: "1000", step: "1" };
export const ballsConfig = { min: "1", max: "75", step: "1" };

export const lotteryBalls = [
  { min: 1, max: 15, style: { backgroundColor: "#3b82f6", color: "#fff", boxShadow: "0 0 14px rgba(59,130,246,0.7)" } },
  { min: 16, max: 30, style: { backgroundColor: "#374151", color: "#fff", boxShadow: "0 4px 12px rgba(0,0,0,0.8), 0 0 0 1px rgba(255,255,255,0.1)" } },
  { min: 31, max: 45, style: { backgroundColor: "#ef4444", color: "#fff", boxShadow: "0 0 14px rgba(239,68,68,0.7)" } },
  { min: 46, max: 60, style: { backgroundColor: "#eab308", color: "#000", boxShadow: "0 0 14px rgba(234,179,8,0.7)" } },
  { min: 61, max: 75, style: { backgroundColor: "#22c55e", color: "#fff", boxShadow: "0 0 14px rgba(34,197,94,0.7)" } },
];

// export const lotteryBalls = [
//   {
//     numbers: [4, 15, 22, 25, 28, 29, 33, 42, 45, 52, 56, 35],
//     style: { backgroundColor: "blue", color: "white" },
//   },
//   {
//     numbers: [1, 2, 9, 12, 13, 21, 23, 31, 46, 48, 49, 32],
//     style: { backgroundColor: "red", color: "white" },
//   },
//   {
//     numbers: [16, 20, 11, 3, 18, 26, 34, 36, 39, 53, 59, 38],
//     style: { backgroundColor: "lightgreen", color: "black" },
//   },
//   {
//     numbers: [8, 10, 14, 24, 30, 37, 41, 50, 54, 55, 57, 58],
//     style: { backgroundColor: "orange", color: "white" },
//   },
//   {
//     numbers: [6, 7, 5, 17, 19, 27, 40, 43, 44, 47, 51, 60],
//     style: { backgroundColor: "pink", color: "black" },
//   },
// ];
